
import React, {useState} from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import {Step1Schema} from './schemas'
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import { makeStyles } from '@material-ui/core/styles';
import {Button,CardActions }  from '@material-ui/core';
import InputField from '../../components/FormFields/InputField';
import { useDispatch} from 'react-redux';
import { alertActions, homologationActions } from '../../_actions';
import { ContactSupportOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

export const Step1 = ({submit, setData, data}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [SelectedFile, setSelectedFile] = useState(null);
 
  
  var files=[]; 
  var documentList = [];
  const formData = new FormData();
  const SubirArchivos=(e,text,index)=>
  {       
     files[index]=e[0];  
     documentList[index]={      
        "name": e[0].name,
        "typeId": index +1     
     }; 
     //console.log(documentList);

    //FormData file1;    
    //file1.append(text, e);    
    //return file1;
  }
  return (
    <Formik
      initialValues={data}
      validationSchema={Step1Schema}
      onSubmit={(values) => {
        //console.log("Esto es data",documentos);
        submit(3);
        //console.log(files);     
         
        setData({ ...files,...data})
        dispatch(homologationActions.insertarTramiteHomologation({ ...files, ...data},documentList)); 
      }}
    >
      <Form>
      <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>   
          
       <label>Resumen de la tesis(Máximo dos cuartillas)</label>
           <br/>          
           
           <InputField 
           
            variant="outlined"
            required
           name='resumen_tesis'
           onChange={(e)=> SubirArchivos(e.target.files,'resumen_tesis',0)
           }           
           id='resumen_tesis'
           type="file"  
           inputProps={{accept:".doc,.docx,.pdf"}}  
                
           />
          
        </Grid>
      
        <Grid item xs={12} sm={6}>   
        <label>Copia del título de Máster (Legalizado) </label>      
        <InputField  
           
           variant="outlined"
           required
           name='titulo_master'       
           onChange={(e)=> SubirArchivos(e.target.files, 'titulo_master',2 )       }
           id="contained-button-file1"
           type="file"
           inputProps={{accept:".doc,.docx,.pdf"}}  
           />      
            
        </Grid>
        
        <Grid item xs={12} sm={6}>   
        <label>Programa de la maestría</label>        
        <InputField 
        
           variant="outlined"
           name="programa_master"  
           onChange={(e)=> SubirArchivos(e.target.files,"programa_master",1)
           }
          id="contained-button-file2"
          type="file"
          inputProps={{accept:".doc,.docx,.pdf"}}  
          />         
        </Grid>
        <Grid item xs={12} sm={6}>
        <label>Copia de la tesis </label>  
        <br/>       
        <InputField
            
            variant="outlined"
            name="tesis "   
            onChange={(e)=> SubirArchivos(e.target.files,"tesis",4)
            }  
            id="contained-button-file3"
            type="file"
            inputProps={{accept:".doc,.docx,.pdf"}}  
            />         
        </Grid>
        <Grid item xs={12} sm={6}> 
        <label>Foto </label>  
        <br/>       
        <InputField         
           variant="outlined"
           required
           name="foto" 
            onChange={(e)=> SubirArchivos(e.target.files,"foto",3)
            }    
           id="contained-button-file4"
           type="file"
           inputProps={{accept:"image/*"}}  
          />         
         </Grid>
         </Grid> 
         <span>
        <Button
                    //disabled={isSubmitting}
                    type="button"
                    variant="contained"                    
                    color="default"
                    onClick={()=> {submit((e)=> e-1)}}                   
                   className={classes.button}
                  >     Anterior  
        </Button>
        <Button
                    //disabled={isSubmitting}
                    type="submit"
                    variant="contained"                    
                    color="primary"
                    //onClick={_handleSubmit}
                    className={classes.button}
                  >     Enviar  
        </Button>
        </span>   
       </Form>
      </Formik>
  );
};







 